import { Injectable } from '@tanbo/vue-di-plugin'
import { TableList, TableMemoryPagination } from '@/services/table-memory-pagination'
import { Http } from '@/services/http'
import { ParamsClean } from '@/common/decorators/params-clean'

export interface QueryParams {
  /** 页码（最小页码：1） */
  page: number
  /** 每页数量 */
  limit: number
  /** 终端id */
  device_id: string
  /** 排序,true-正序，false-倒序 */
  asc?: boolean
  /** 排序字段（端口号：port_num，协议：protocol，绑定IP：bind_ip，监听的进程名：process_name） */
  sort?: string
  /** 风险参考 0 全部 1 风险 2 未知 */
  is_risk_port?: number
  key_word: string
  /** 是否使用内存数据 */
  useMemory: boolean
}

export interface PortItem {
  /** 端口号 */
  port_num: number
  /** 协议 */
  protocol: string
  /** 监听的进程名 */
  process_name: string
  /** 绑定IP */
  bind_ip?: string
  /** 终端数量 */
  device_total?: number
  /** 风险参考（是否已知：0->未知，1->已知） */
  is_known_risk?: number
  /** 风险参考（详情说明） */
  risk_detail?: string
  /** 系统类型 1-windows 2-linux 3-win server */
  system_type: number
}

export interface BlockPortItem {
  /** 起始端口 */
  port_start: number
  /** 结束端口 */
  port_end: number
}

export interface BlockParams {
  /** 终端设备id */
  device_id: string
  /** 选择类型, 0-指定端口,1-终端关联全部端口 */
  select_type: number
  /** 端口列表 */
  port_list: number[]
}

@Injectable()
export class PortListDrawerService extends TableMemoryPagination<QueryParams, PortItem> {
  constructor (private http: Http) {
    super()
  }

  isEqual (left: PortItem, right: PortItem): boolean {
    return left.port_num === right.port_num
  }

  @ParamsClean()
  getListByServer (params: QueryParams): Promise<TableList<PortItem>> {
    return this.http.post<{
      list: PortItem[]
      total: number
    }>('/portcontrol/device-port/list', params)
  }

  doPortcontrolTerminalBlockedRulesSave (data: BlockParams) {
    return this.http.post<{
      /** 下发指令任务id */
      task_id: string
    }>('/portcontrol/terminal-blocked-rules/save', data)
  }
}
